
































































































































































































































import {
  Component, Mixins,
} from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import { getModule } from 'vuex-module-decorators';
import BankAccountBody from '@/components/Table/BankAccountBody.vue';
import BankAccountData from '@/data/BankAccountData';
import BankAccountModule from '@/store/modules/BankAccount';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';

@Component({
  components: {
    Table,
    BankAccountBody,
  },
})
export default class BankAccountView extends Mixins(
  ToolMixin, ErrorHandleMixin,
) {
  TableHeadBankAccount = BankAccountData.TableHeadBankAccount;

  BankAccountInstance = getModule(BankAccountModule, this.$store);

  data: any[] = [];

  dataNameList: any = [];

  editModal = false;

  removeModal = false;

  modalAddbank = false;

  MessageModel: any = '';

  MessageData: any = '';

  MessageEdit: any = '';

  bankName = '';

  accountName = '';

  accountNo = '';

  imageUrl = '';

  itemSelect = '';

  indexSelect = '';

  async created() {
    this.fetchBankAccount();
  }

  Addbank() {
    this.modalAddbank = true;
  }

  selectBank(data: any) {
    this.bankName = data.name.en;
    this.imageUrl = data.imgUrl;
  }

  async createBank() {
    const createbank = {
      bankName: this.bankName,
      accountName: this.accountName,
      accountNo: this.accountNo,
      imageUrl : this.imageUrl,
    };
    const res = await this.BankAccountInstance.CreateBankAccount(createbank);
    if (res.code) {
      this.checkError(res);
    } else {
      this.bankName = '';
      this.accountName = '';
      this.accountNo = '';
      this.modalAddbank = false;
      this.GeneralInstance.toggleLoading(false);
      this.fetchBankAccount();
    }
  }

  openModal(idx, index) {
    this.editModal = true;
    this.itemSelect = `${idx}`;
    this.indexSelect = `${index}`;
    this.MessageModel = { ...this.BankAccountInstance.bankaccountList[index] };
    this.bankName = this.MessageModel.namebank;
    this.accountName = this.MessageModel.bankacc[this.itemSelect].accountname;
    this.accountNo = this.MessageModel.bankacc[this.itemSelect].accountno;
  }

  async fetchBankAccount() {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.BankAccountInstance.FetchBankAccount();
    this.data = this.BankAccountInstance.bankaccountList;
    if (res.code) {
      this.checkError(res);
    }
    this.GeneralInstance.toggleLoading(false);
    await this.BankAccountInstance.FetchBankName();
    this.dataNameList = this.BankAccountInstance.bankNameList;
  }

  async submit() {
    this.MessageData = { ...this.BankAccountInstance.bankaccountList[this.indexSelect] };
    this.MessageEdit = { ...this.MessageData.bankacc[this.itemSelect] };
    const updateBank = {
      nameid: this.MessageData._id,
      itemsection: this.MessageEdit,
      namebank: this.bankName,
      accountname: this.accountName,
      accountno: this.accountNo,
    };
    const res = await this.BankAccountInstance.UpdateBankAccount(updateBank);
    this.checkError(res);
    this.bankName = '';
    this.accountName = '';
    this.accountNo = '';
    this.editModal = false;
    this.fetchBankAccount();
    await this.BankAccountInstance.FetchBankName();
  }

  async remove(idx, index) {
    this.removeModal = true;
    this.itemSelect = `${idx}`;
    this.indexSelect = `${index}`;
    this.MessageModel = { ...this.BankAccountInstance.bankaccountList[index] };
    this.bankName = this.MessageModel.namebank;
    this.accountName = this.MessageModel.bankacc[this.itemSelect].accountname;
    this.accountNo = this.MessageModel.bankacc[this.itemSelect].accountno;
  }

  async submitRemove() {
    this.MessageData = { ...this.BankAccountInstance.bankaccountList[this.indexSelect] };
    this.MessageEdit = { ...this.MessageData.bankacc[this.itemSelect] };
    const res = await this.BankAccountInstance.DeleteBankAccount({
      nameid: this.MessageData._id,
      itemsection: this.MessageEdit._id,
    });
    this.checkError(res);
    this.removeModal = false;
    this.fetchBankAccount();
  }
}
